export default "__VITE_ASSET__d5dc8f03__"